import { render, staticRenderFns } from "./GenericDropBox.vue?vue&type=template&id=6f2f0b16&scoped=true"
import script from "./GenericDropBox.vue?vue&type=script&lang=js"
export * from "./GenericDropBox.vue?vue&type=script&lang=js"
import style0 from "./GenericDropBox.vue?vue&type=style&index=0&id=6f2f0b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f0b16",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
